module.exports = __webpack_public_path__ + "Graphik-RegularItalic.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/fonts/Graphik-RegularItalic.woff
 ** module id = 196
 ** module chunks = 1
 **/